/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { defaultPrimitive, ILandingPrimitive } from "src/modules/pe-landing-module/data/interfaces"
import { PersonPrimitive } from "../../primitive"
import { ICardFieldProps } from "../cards/CardField"

const CardFieldPerson = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props 
     
    useEffect(() => { 
            addCSSClass(
                `landing-card-field-person-${section.id + "-" + value?.id}`,
                `.landing-card-field-person-${section.id + "-" + value?.id} {
                    .landing-image-link {
                        width: ${field.avatarWidth}px; 
                        height: ${field.avatarHeight}px;
                        margin: 10px;
                    }
                }
                `
            )
            return () => removeCSSClass(`landing-card-field-person-${section.id + "-" + value?.id}`)
        }, [])
    const style = { 
        ...field.style, 
        ...value.style 
    } 
    style.backgroundColor = undefined  
    const primitive: ILandingPrimitive = {
        ...defaultPrimitive(),
        ...field,
        ...value, 
        data: {...field.data, ...value.data},
        style,
        id: section.id + "-" + value?.id,
    }
    
    return <div 
        className={`landing-card-field landing-card-field-person landing-card-field-person-${section.id + "-" + value.id} ${value.className}`}  
        data-card-field-id={i} 
        card-field-section-id={section.id}
    >  
        <PersonPrimitive 
            primitive={primitive as any}
        />
    </div>
}
export default CardFieldPerson